'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomStylesController = function () {
    function CustomStylesController($scope, userService, $location) {
        _classCallCheck(this, CustomStylesController);

        this.$scope = $scope;
        this.$location = $location;
        this.userService = userService;
    }

    _createClass(CustomStylesController, [{
        key: 'setStyles',
        value: function setStyles() {
            var _this = this;

            _.each(['colorPrimaryHighlight', 'colorButton', 'colorNegativeButton', 'colorShoppingCartButton', 'colorReservationBackground', 'colorShoppingCartBackground', 'colorShoppingCartText', 'colorPrimaryBackground', 'colorPrimaryText', 'colorSecondaryBackground', 'colorSecondaryText', 'colorNeutralText', 'colorNeutralBackground', 'colorTertiaryBackground', 'colorNeutralDistinctBackground', 'colorNeutralDistinctText', 'colorHeading', 'colorParagraph', 'colorMenuBackground', 'colorMenuText', 'colorMenuActiveBackground', 'colorMenuActiveText'], function (colorName) {
                var search = _this.$location.search();
                if (colorName in search) {
                    _this.$scope[colorName] = search[colorName];
                } else {
                    _this.$scope[colorName] = 'unspecified';
                }
            });
            var user = this.userService.getCurrentUser();
            if (!user) {
                return;
            }
            var userColors = user.getColors();
            if (!userColors) {
                return;
            }
            _.each(userColors, function (color, colorName) {
                _this.$scope[colorName] = color;
            });
        }
    }, {
        key: '$onInit',
        value: function $onInit() {
            var _this2 = this;

            this.unregister = this.$scope.$on('userDataChanged', function (e) {
                _this2.setStyles();
            });
            this.unregister2 = this.$scope.$on('$locationChangeSuccess', function (e) {
                _this2.setStyles();
            });
        }
    }, {
        key: '$onDestroy',
        value: function $onDestroy() {
            this.unregister();
            this.unregister2();
        }
    }]);

    return CustomStylesController;
}();

CustomStylesController.$inject = ['$scope', 'userService', '$location'];

_module3.default.directive('customStyles', function () {
    return {
        restrict: 'AE',
        controller: CustomStylesController,
        controllerAs: '$ctrl',
        scope: {},
        template: function template(element, attrs) {
            var template = attrs['customStyles'] ? attrs['customStyles'] : 'portal';
            return require('raw!./customStyles/' + template + '.css.tmpl');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/core/customStyles.js
// module id = 42
// module chunks = 0 2